import React, { FC } from 'react';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

import { global } from '../styles';
import theme from 'theme';

interface Props {
  text: string;
}

const styles = {
  keyPoint: {
    ...global.header4,
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  keyPointIcon: {
    fontSize: 8,
    color: 'white',
  },
} as const;

const KeyPoint: FC<Props> = ({ text }) => (
  <Grid container alignItems="center" spacing={2}>
    <Grid>
      <CircleIcon sx={styles.keyPointIcon} />
    </Grid>
    <Grid>
      <Typography display="inline" sx={styles.keyPoint}>
        {text}
      </Typography>
    </Grid>
  </Grid>
);

export default KeyPoint;
